import React from 'react';
import { CheckCircle, ArrowRight, Trash2, Shield } from 'lucide-react';
import '../AccountDeletionSuccessModal/AccountDeletionSuccessModal.css';

interface AccountDeletionSuccessModalProps {
  onContinue: () => void;
}

const AccountDeletionSuccessModal: React.FC<AccountDeletionSuccessModalProps> = ({ onContinue }) => {
  return (
    <div className="homecookt-deletion-success-overlay">
      <div className="homecookt-deletion-success-modal">
        {/* Animated Success Icon */}
        <div className="homecookt-deletion-icon-container">
          <div className="homecookt-deletion-icon-circle">
            <CheckCircle size={60} />
          </div>
          <div className="homecookt-deletion-particles">
            <Shield className="homecookt-particle homecookt-particle-1" size={16} />
            <Trash2 className="homecookt-particle homecookt-particle-2" size={14} />
            <Shield className="homecookt-particle homecookt-particle-3" size={18} />
            <Trash2 className="homecookt-particle homecookt-particle-4" size={12} />
          </div>
        </div>

        {/* Success Content */}
        <div className="homecookt-deletion-content">
          <h2 className="homecookt-deletion-title">Account Deleted Successfully</h2>
          <p className="homecookt-deletion-subtitle">
            Your HomeCookt account has been permanently deleted. All your personal data has been securely removed from our systems.
          </p>
        </div>

        {/* Deletion Details */}
        <div className="homecookt-deletion-details">
          <h3 className="homecookt-details-title">What Happened?</h3>
          <div className="homecookt-details-grid">
            <div className="homecookt-detail-card">
              <span className="homecookt-detail-emoji">🗑️</span>
              <span className="homecookt-detail-text">Account permanently deleted</span>
            </div>
            <div className="homecookt-detail-card">
              <span className="homecookt-detail-emoji">🔒</span>
              <span className="homecookt-detail-text">Personal data securely removed</span>
            </div>
            <div className="homecookt-detail-card">
              <span className="homecookt-detail-emoji">🚪</span>
              <span className="homecookt-detail-text">You've been logged out</span>
            </div>
          </div>
        </div>

        {/* Security Notice */}
        <div className="homecookt-deletion-security-notice">
          <div className="homecookt-security-icon">
            <Shield size={20} />
          </div>
          <div className="homecookt-security-text">
            <strong>Data Protection:</strong> Your information has been permanently removed in compliance with data protection regulations.
          </div>
        </div>

        {/* Continue Button - Updated text */}
        <button 
          onClick={onContinue}
          className="homecookt-deletion-continue-button"
        >
          <span>Return to Landing Page</span>
          <ArrowRight size={18} />
        </button>

        {/* Footer Message */}
        <div className="homecookt-deletion-footer">
          <p>Thank you for being part of the HomeCookt community. You're welcome back anytime!</p>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletionSuccessModal;